import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StatusListComponent } from './status-list/status-list.component';
import { StatusEditComponent } from './status-edit/status-edit.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [BrowserModule, ReactiveFormsModule, MaterialModule, RouterModule, TranslateModule],
  declarations: [StatusListComponent, StatusEditComponent]
})
export class OfferLifecycleModule {}



// WEBPACK FOOTER //
// ./src/app/modules/lifecycle/lifecycle.module.ts